export const ENV = {
  PRODUCTION: false,
  NAME: "development",
  CAS: {
    DOMAIN: 'https://cas.cwsfirabarcelona.com/login',
    CSS_URL: 'https://stg-mediarepository.cwsfirabarcelona.com/shows/backoffice/css/cas.css',
    LANG: 'es',
    SERVICE: 'http://ecatalogue-backofficedev.cwsfirabarcelona.com/login',
    LOGOUT: 'https://cas.cwsfirabarcelona.com/logout'
  },
  APP: {
    FRONTEND_URL: 'https://ecatalogue-backofficedev.cwsfirabarcelona.com',
    BACKEND_API: 'https://ecataloguedev-api.cwsfirabarcelona.com/v1',
    USEARCH_API: 'https://ecatalogueusearchdev-api.cwsfirabarcelona.com/v1',
    FRONTOFFICE_URL: 'https://ecataloguedev.cwsfirabarcelona.com',
    MEDIA_REPOSITORY: 'https://dev-mediarepository.cwsfirabarcelona.com',
    MEDIA_API: 'https://media.cwsfirabarcelona.com/v1'
  },
  BASE_PATH: {
    USERS: 'https://users.cwsfirabarcelona.com/v1',
    DIGPLATFORM: 'https://registration-digitalplatformdev-api.cwsfirabarcelona.com'
  },
  MAPS: {
    BASE_URI: "https://mapsdev.cwsfirabarcelona.com/ecatalogue",
    BASE_VISOR_URI: "https://visordev.cwsfirabarcelona.com"
  },
  MOCKS: false,
  MOCKS_BASE_PATH: 'http://localhost:3000',
  MEDIA_REPOSITORY: 'https://dev-mediarepository.cwsfirabarcelona.com',
  CAPTCHA: {
    SITEKEY: '6LcJQRwmAAAAAK9-tyn-vrnlXqJh3NXYnikdQUiV',
    USER: "firabarcelona.captcha@gmail.com",
    PASSWORD: "Fira2023*"
  },
  REGISTRATION_FRONTOFFICE_URL: "https://registration-frontofficedev.cwsfirabarcelona.com/#"
};
